export function wait(ms: number): Promise<void> {
  if (ms === Infinity) {
    // return a promise that never resolves
    return new Promise(() => {}); // eslint-disable-line no-empty-function
  }

  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Yields control to the event loop so the timer queue gets a chance to
 * run between bursts of synchronous work. Useful when a long chain of
 * microtask-resolving `await`s would otherwise starve `setInterval`
 * callbacks (e.g. botman's heartbeat sender).
 */
export function yieldToEventLoop(): Promise<void> {
  return new Promise((resolve) => {
    setImmediate(resolve);
  });
}
